export const ROUTE_PATHS = {
  MAIN: '/',
  RESET_PASSWORD: 'reset-password',
  EMAIL_VERIFY: 'email-verify',
  UNINSTALL_EXTENSION: 'uninstall-extension',
  DASHBOARD: 'dashboard',
  ACCOUNT: 'account',
  PROJECTS: 'projects',
  SUBSCRIPTION: 'subscription',
  AUTH: '/auth',
  REGISTER_OLD: '/register',
  SIGN_UP: '/sign-up',
  SIGN_UP_EMAIL: '/sign-up-email',
  SIGN_UP_GOOGLE: '/sign-up-google',
  DASHBOARD_PROJECT: '/dashboard/projects/:id',
  DASHBOARD_PROJECT_CONTROL_DESK: '/dashboard/projects/:id/control-desk',
  DASHBOARD_PROJECT_NEW: '/dashboard/projects/new',
  DASHBOARD_PROJECT_NEW_STEP: '/dashboard/projects/new/:step',
  DASHBOARD_PROJECT_NEW_STEP_EDIT: '/dashboard/projects/:id/new/:step',
  DASHBOARD_PROJECT_ANALYTICS: '/dashboard/projects/:id/analytics',
  DASHBOARD_PROJECT_INTEGRATIONS: '/dashboard/projects/:id/integrations',
  DASHBOARD_PROJECT_CONVERSATIONS: '/dashboard/projects/:id/conversations',
  AI_KNOWLEDGE_BASE: '/dashboard/ai-knowledge-base',
  CURRENT_AI_KNOWLEDGE_BASE: '/dashboard/ai-knowledge-base/:id',
  DASHBOARD_PROJECT_CONFIGURATION: '/dashboard/projects/:id/configuration',
  HOME: '/dashboard/home',
  WELCOME: 'welcome',
  ONBOARDING: '/onboarding',
  ONBOARDING_STEPS: '/onboarding/:step',
};
